import { render, staticRenderFns } from "./ItemListTiles.vue?vue&type=template&id=1ddc42b1&"
import script from "./ItemListTiles.ts?vue&type=script&lang=ts&"
export * from "./ItemListTiles.ts?vue&type=script&lang=ts&"
import style0 from "./ItemListTiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/BuildAgent/work/daf3bd281f341f7b/crowdworx/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VExpandTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VContainer,VExpandTransition,VFlex,VLayout,VProgressLinear,VSpacer})
